export default __webpack_public_path__ + "static/media/Hammer of the Living Tarim.5bff2422.jpg";